import { inject, ref, unref, computed } from 'vue';

type MobileOS = 'ios' | 'android';

const ANDROID_DETECT = /android/i;
const IOS_DETECT = /iPad|iPhone|iPod/;

export const detectMobileOS = (): MobileOS | null => {
  if (typeof navigator === 'undefined') {
    return null;
  }
  const userAgent = navigator.userAgent || (window as any).opera || '';
  if (ANDROID_DETECT.test(userAgent)) {
    return 'android';
  }
  if (IOS_DETECT.test(userAgent) && !(window as any).MSStream) {
    return 'ios';
  }
  return null;
};

export const useDevice = () => {
  const view = inject<any>('view', 'mobile');
  const os = ref<MobileOS | null>(detectMobileOS());
  const isMobile = computed(() => unref(view) === 'mobile');

  const installationTab = computed<MobileOS>(() =>
    !isMobile.value || os.value === 'ios' ? 'ios' : 'android'
  );

  return { os, isMobile, installationTab };
};
